import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-5 text-fau-blue" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SubmitFailedScreen',
  props: {
    submit: { type: Function },
    isMobile: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-4xl mb-16 text-fau-blue-bright" }, " Something went wrong... ", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-2xl mb-16 text-fau-blue-bright" }, "Press Try Again", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "bg-fau-blue-bright text-white p-5",
        ref: "button",
        type: "button",
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (__props.submit && __props.submit(...args)), ["prevent"]))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("span", null, "Press to Submit", -1)
      ]))], 512),
      (!__props.isMobile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "border border-black w-10 h-0" }, null, -1)),
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (__props.submit && __props.submit(...args)), ["prevent"]))
            }, " Press Enter")
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})